// Standard SMS segmentation (GSM-7: 160/153, Unicode: 70/67).
// https://www.twilio.com/docs/glossary/what-sms-character-limit
// This is an estimate; THSMS's actual debit remains authoritative.
const gsmBasic = new Set(Array.from("@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà"));
const gsmExtended = new Set(Array.from('\f^{}\\[~]|€'));
export function smsCredits(message: string) {
  // The outreach sender transmits body.trim(), with no appended title or link.
  const characters = Array.from(message.trim());
  const unicode = characters.some(character => !gsmBasic.has(character) && !gsmExtended.has(character));
  const weights = characters.map(character => unicode ? character.length : gsmExtended.has(character) ? 2 : 1);
  const units = weights.reduce((sum, value) => sum + value, 0);
  const singleLimit = unicode ? 70 : 160;
  const multipartLimit = unicode ? 67 : 153;
  let credits = units === 0 ? 0 : 1;
  if (units > singleLimit) {
    let used = 0; credits = 1;
    for (const weight of weights) {
      // An escaped GSM character or emoji must stay within one segment.
      if (used + weight > multipartLimit) { credits++; used = 0; }
      used += weight;
    }
  }
  return {credits, units, singleLimit, multipartLimit, encoding: unicode ? 'Unicode' : 'GSM-7'};
}
